/// <amd-module name="Artifacts/Pypi/components/PypiPackageAttributes" />
import { PackageDependencies } from "Artifacts/Package/components/package-details-common/PackageDependencies";
import {
  IProjectAttribute,
  PackageDevelopment,
} from "Artifacts/Package/components/package-details-common/PackageDevelopment";
import { PackageProvenance } from "Artifacts/Package/components/package-details-common/PackageProvenance";
import { PackageStats } from "Artifacts/Package/components/package-details-common/PackageStats";
import { PackageTags } from "Artifacts/Package/components/package-details-common/PackageTags";
import * as PackageRes from "Artifacts/Package/Resources";
import { PyPiPackagePeople } from "Artifacts/Pypi/components/PyPiPackagePeople";
import { IPyPiProtocolMetadata } from "Artifacts/Pypi/IPyPiProtocolMetadata";
import * as PyPiRes from "Artifacts/Pypi/Resources";
import { IProtocolOverviewProps } from "Artifacts/Root/protocols/types";
import * as React from "react";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { useComponentContext } from "VSS/Platform/Layout";

const PypiAttributes: React.FC<IProtocolOverviewProps> = ({ feed, pkg, version }) => {
  const { pageContext } = useComponentContext();
  const isProvenanceEnabled = isFeatureFlagEnabled(
    pageContext,
    "Packaging.Feed.WebAccess.Provenance",
    false,
  );
  const isMetricsEnabled = isFeatureFlagEnabled(
    pageContext,
    "Packaging.Feed.WebAccess.Metrics",
    false,
  );

  const pypiMetadata =
    version.protocolMetadata && version.protocolMetadata.data
      ? (version.protocolMetadata.data as IPyPiProtocolMetadata)
      : ({} as IPyPiProtocolMetadata);

  const projectAttributes: IProjectAttribute[] = [];

  return (
    <section className="package-overview-attributes" aria-label={PackageRes.PackageMetadata}>
      <div className="nuget-overview-attributes-panel">
        <PackageProvenance
          pageContext={pageContext}
          feed={feed}
          packageId={pkg.id}
          versionId={version.id}
          publishDate={new Date(version.publishDate)}
          isProvenanceEnabled={isProvenanceEnabled}
          isProvenanceSupported={true}
        />

        <PyPiPackagePeople
          pageContext={pageContext}
          author={pypiMetadata.author}
          authorEmail={pypiMetadata.authorEmail}
          maintainer={pypiMetadata.maintainer}
          maintainerEmail={pypiMetadata.maintainerEmail}
        />

        <PackageDevelopment
          pageContext={pageContext}
          projectAttributes={projectAttributes}
          packageSummary={pkg}
          packageVersion={version}
          upstreamSources={feed.upstreamSources}
        />

        {isMetricsEnabled && (
          <PackageStats
            pageContext={pageContext}
            feed={feed}
            package={pkg}
            versionId={version.id}
            isMetricsEnabled={isMetricsEnabled}
          />
        )}

        <PackageDependencies
          pageContext={pageContext}
          feed={feed}
          packageSummary={pkg}
          packageVersion={version}
        />

        <PackageTags tags={pypiMetadata.classifiers} title={PyPiRes.PyPiPackage_Classifiers} />
        <PackageTags title={PackageRes.PackageDetails_VersionsTable_Views} tags={version.views} />
      </div>
    </section>
  );
};

export { PypiAttributes };
